import PageContainer from '../components/common/PageContainer'
import ProcessPageHeader from '../components/process/ProcessPageHeader'
import Button from '@mui/material/Button'
import { useSetRecoilState } from 'recoil'
import { modalContentState, modalOpenState } from '../atoms/layout'
import NewAccountForm from '../components/account/NewAccountModal'
import AccountsTable from '../components/account/AccountsTable'

export default function Users() {
  const setModalContent = useSetRecoilState(modalContentState)
  const setModalOpen = useSetRecoilState(modalOpenState)

  function openNewAccountModal() {
    setModalContent(<NewAccountForm />)
    setModalOpen(true)
  }

  return (
    <PageContainer header={<ProcessPageHeader />}>
      <div className="mx-auto max-w-full overflow-auto">
        <div className="m-6">
          <Button onClick={openNewAccountModal} variant="contained">
            کاربر جدید
          </Button>
        </div>
        <AccountsTable />
      </div>
    </PageContainer>
  )
}
